import { UiStatus } from "../../_shared/Emails/Emails.types";

export const isRemediable = (uiStatus: string) => {
  return ![UiStatus.AUTO_REMEDIATED, UiStatus.REMEDIATED].includes(
    uiStatus as UiStatus,
  );
};

export const isMarkableAsSafe = (uiStatus: string) =>
  uiStatus !== UiStatus.MARKED_AS_SAFE;
